import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-multi-select',
  template: `
    <ng-select [items]="to.options"
               [bindLabel]="labelProp"
               [bindValue]="valueProp"
               [multiple]="to.multiple"
               [placeholder]="to.placeholder"
               [formControl]="formControl"
               [formlyAttributes]="field">
    </ng-select>
  `,
})
export class FormlyFieldMultiSelect extends FieldType {
  get labelProp(): string {
    return this.to?.labelProp || 'label';
  }

  get valueProp(): string {
    return this.to?.valueProp || 'value';
  }
}
